
// ABOUTME: Security audit page with URL routing support
// ABOUTME: Displays security monitoring and audit dashboard

import React from 'react';
import SecurityAuditDashboard from '@/components/admin/SecurityAuditDashboard';

const SecurityAuditPage = () => {
  return <SecurityAuditDashboard />;
};

export default SecurityAuditPage;
